import React from 'react';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import ProjectCostsView from './ProjectCostsView';

import { CompileTOVS } from "@app/utils/CompileTOVS";
import { saveAs } from "file-saver";
import { Packer } from "docx";
import { DocumentCreator } from "@app/utils/DocumentCreator";

class ConnectedProjectCostsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            locale: this.props.locale ? this.props.locale : 'en',
            pageLoad: '',
            workType1: '',
            workType2: '',
            workType3: '',
            service1: '',
            service2: '',
            service3: '',
            supplier1: '',
            supplier2: '',
            supplier3: '',
            cost1: '',
            cost2: '',
            cost3: '',
            expectedCosts: '',
            amountRequested: '',
            validationErrors: {
                workType1: { show: false, check: null, errorMessage: ''  },
                workType2: { show: false, check: null, errorMessage: ''  },
                workType3: { show: false, check: null, errorMessage: ''  },
                service1: { show: false, check: null, errorMessage: ''  },
                service2: { show: false, check: null, errorMessage: ''  },
                service3: { show: false, check: null, errorMessage: ''  },
                supplier1: { show: false, check: null, errorMessage: ''  },
                supplier2: { show: false, check: null, errorMessage: ''  },
                supplier3: { show: false, check: null, errorMessage: ''  },
                cost1: { show: false, check: null, errorMessage: ''  },
                cost2: { show: false, check: null, errorMessage: ''  },
                cost3: { show: false, check: null, errorMessage: ''  },
                expectedCosts: { show: false, check: null, errorMessage: ''  },
                amountRequested: { show: false, check: null, errorMessage: ''  }
            },
            isLoading: false,
            errorMessage: '',
            successMessage: '',
            loadToSubmitTime: '',
            shareMessage: ''
        };
        this.handleCost1 = this.handleCost1.bind(this);
        this.handleCost2 = this.handleCost2.bind(this);
        this.handleCost3 = this.handleCost3.bind(this);
        this.handleWorkType1 = this.handleWorkType1.bind(this);
        this.handleWorkType2 = this.handleWorkType2.bind(this);
        this.handleWorkType3 = this.handleWorkType3.bind(this);
        this.handleService1 = this.handleService1.bind(this);
        this.handleService2 = this.handleService2.bind(this);
        this.handleService3 = this.handleService3.bind(this);
        this.handleSupplier1 = this.handleSupplier1.bind(this);
        this.handleSupplier2 = this.handleSupplier2.bind(this);
        this.handleSupplier3 = this.handleSupplier3.bind(this);
        this.handleExpectedCosts = this.handleExpectedCosts.bind(this);
        this.handleAmountRequested = this.handleAmountRequested.bind(this);
        this.generateDoc = this.generateDoc.bind(this);
    }

    componentDidMount() {
        if (this.state.pageLoad === '') {
            this.setState({
                pageLoad: new Date().valueOf()
            });
        }
        for (var i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).startsWith('tovsForm.expenditure.')) {
                this.setState({
                    [localStorage.key(i).substring(21)]: localStorage.getItem(localStorage.key(i))
                });
            }
        }
    }

    handleWorkType1(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isWorkType1Valid = value !== '';
        validationErrors.workType1.show = !isWorkType1Valid;
        if (isWorkType1Valid) {
            validationErrors.workType1.check = true;
            validationErrors.workType1.errorMessage = '';
            localStorage.setItem('tovsForm.expenditure.workType1', value);
        }
        else {
            validationErrors.workType1.check = false;
            validationErrors.workType1.errorMessage = 'Work Type 1 is empty. You should have at least one type of work to do.';
        }
        this.setState({
            workType1: value,
            validationErrors: validationErrors
        });
    }
    
    handleWorkType2(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.workType2.check = true;
        validationErrors.workType2.errorMessage = '';
        localStorage.setItem('tovsForm.expenditure.workType2', value);
        this.setState({
            workType2: value,
            validationErrors: validationErrors
        });
    }
    
    handleWorkType3(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.workType3.check = true;
        validationErrors.workType3.errorMessage = '';
        localStorage.setItem('tovsForm.expenditure.workType3', value);
        this.setState({
            workType3: value,
            validationErrors: validationErrors
        });
    }

    handleService1(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isService1Valid = value !== '';
        validationErrors.service1.show = !isService1Valid;
        if (isService1Valid) {
            validationErrors.service1.check = true;
            validationErrors.service1.errorMessage = '';
            localStorage.setItem('tovsForm.expenditure.service1', value);
        }
        else {
            validationErrors.service1.check = false;
            validationErrors.service1.errorMessage = 'Service 1 is empty. You should require at least one type of service or product.';
        }
        this.setState({
            service1: value,
            validationErrors: validationErrors
        });
    }
    
    handleService2(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.service2.check = true;
        validationErrors.service2.errorMessage = '';
        localStorage.setItem('tovsForm.expenditure.service2', value);
        this.setState({
            service2: value,
            validationErrors: validationErrors
        });
    }
    
    handleService3(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.service3.check = true;
        validationErrors.service3.errorMessage = '';
        localStorage.setItem('tovsForm.expenditure.service3', value);
        this.setState({
            service3: value,
            validationErrors: validationErrors
        });
    }

    handleSupplier1(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isSupplier1Valid = value !== '';
        validationErrors.supplier1.show = !isSupplier1Valid;
        if (isSupplier1Valid) {
            validationErrors.supplier1.check = true;
            validationErrors.supplier1.errorMessage = '';
            localStorage.setItem('tovsForm.expenditure.supplier1', value);
        }
        else {
            validationErrors.supplier1.check = false;
            validationErrors.supplier1.errorMessage = 'Supplier 1 is empty. You should require at least one supplier.';
        }
        this.setState({
            supplier1: value,
            validationErrors: validationErrors
        });
    }
    
    handleSupplier2(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.supplier2.check = true;
        validationErrors.supplier2.errorMessage = '';
        localStorage.setItem('tovsForm.expenditure.supplier2', value);
        this.setState({
            supplier2: value,
            validationErrors: validationErrors
        });
    }
    
    handleSupplier3(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.supplier3.check = true;
        validationErrors.supplier3.errorMessage = '';
        localStorage.setItem('tovsForm.expenditure.supplier3', value);
        this.setState({
            supplier3: value,
            validationErrors: validationErrors
        });
    }

    handleCost1(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isCost1Valid = value.match(/^\€?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$/) !== null;

        if (isCost1Valid) {
            validationErrors.cost1.check = true;
            validationErrors.cost1.errorMessage = '';
            localStorage.setItem('tovsForm.expenditure.cost1', value);
        }
        else {
            validationErrors.cost1.check = false;
            validationErrors.cost1.errorMessage = 'The amount does not seem right.';
        }
        validationErrors.cost1.show = !isCost1Valid;
        this.setState({
            cost1: value,
            validationErrors: validationErrors
        });
    }

    handleCost2(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isCost2Valid = value.match(/^\€?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$/) !== null;

        if (isCost2Valid) {
            validationErrors.cost2.check = true;
            validationErrors.cost2.errorMessage = '';
            localStorage.setItem('tovsForm.expenditure.cost2', value);
        }
        else {
            validationErrors.cost2.check = false;
            validationErrors.cost2.errorMessage = 'The amount does not seem right.';
        }
        validationErrors.cost2.show = !isCost2Valid;
        this.setState({
            cost2: value,
            validationErrors: validationErrors
        });
    }

    handleCost3(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isCost3Valid = value.match(/^\€?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$/) !== null;

        if (isCost3Valid) {
            validationErrors.cost3.check = true;
            validationErrors.cost3.errorMessage = '';
            localStorage.setItem('tovsForm.expenditure.cost3', value);
        }
        else {
            validationErrors.cost3.check = false;
            validationErrors.cost3.errorMessage = 'The amount does not seem right.';
        }
        validationErrors.cost3.show = !isCost3Valid;
        this.setState({
            cost3: value,
            validationErrors: validationErrors
        });
    }

    handleExpectedCosts(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isExpectedCostsValid = value > 0;

        if (isExpectedCostsValid) {
            validationErrors.expectedCosts.check = true;
            validationErrors.expectedCosts.errorMessage = '';
            localStorage.setItem('tovsForm.expenditure.expectedCosts', value);
        }
        else {
            validationErrors.expectedCosts.check = false;
            validationErrors.expectedCosts.errorMessage = 'The amount does not seem right. You will be reimbursed for 90% of your spend, up to a max reimbursement of €2,500.';
        }
        validationErrors.expectedCosts.show = !isExpectedCostsValid;
        this.setState({
            expectedCosts: value,
            validationErrors: validationErrors
        });
    }

    handleAmountRequested(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isAmountRequestedValid = value > 0 && value < 2501;

        if (isAmountRequestedValid) {
            validationErrors.amountRequested.check = true;
            validationErrors.amountRequested.errorMessage = '';
            localStorage.setItem('tovsForm.expenditure.amountRequested', value);
        }
        else {
            validationErrors.amountRequested.check = false;
            validationErrors.amountRequested.errorMessage = 'The amount does not seem right. You can request an amount up to and including €2,500 (excluding VAT).';
        }
        validationErrors.amountRequested.show = !isAmountRequestedValid;
        this.setState({
            amountRequested: value,
            validationErrors: validationErrors
        });
    }

    generateDoc() {
        const data = new CompileTOVS().compile(); 
        var documentCreator = new DocumentCreator();
        var doc = documentCreator.create(data);

        Packer.toBlob(doc).then(function (blob) {
            saveAs(blob, "TradingOnlineVoucherScheme-" + Date.now() + ".docx");
        });
    }

    generateViewProps() {
        return {
            ...this.state,
            generateDoc: this.generateDoc,
            handleCost1: this.handleCost1,
            handleCost2: this.handleCost2,
            handleCost3: this.handleCost3,
            handleWorkType1: this.handleWorkType1,
            handleWorkType2: this.handleWorkType2,
            handleWorkType3: this.handleWorkType3,
            handleService1: this.handleService1,
            handleService2: this.handleService2,
            handleService3: this.handleService3,
            handleSupplier1: this.handleSupplier1,
            handleSupplier2: this.handleSupplier2,
            handleSupplier3: this.handleSupplier3,
            handleExpectedCosts: this.handleExpectedCosts,
            handleAmountRequested: this.handleAmountRequested
        };
    }

    render() {
        const viewProps = this.generateViewProps();
        return (
            <ProjectCostsView {...viewProps} />
        );
    }
}

const mapStateToProps = state => {
    return {
        locale: state.i18n.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLocale: locale => dispatch(setLocale(locale))
    };
};

const ProjectCostsContainer = injectIntl(connect(mapStateToProps,mapDispatchToProps)(ConnectedProjectCostsContainer));

export default ProjectCostsContainer;